import React, { useMemo } from 'react'
import { ContentBlock } from 'components/ContentBlock'
import { DataTable } from 'components//DataTable'
import { users } from '../tableColumns'
import { withRouter } from 'react-router'
import get from 'lodash/get'
import { useTranslation } from 'react-i18next'
import useLocale from 'hooks/useLocale'

const Users = ({ data, history }) => {
	const [t] = useTranslation()
	const locale = useLocale()
	const cols = useMemo(() => users(t, locale), [locale])
	const gotoUser = (_, { original: closingUser }) => {
		const userId = get(closingUser, ['user', 'id'])
		if(userId) {
			history.push(`/benutzer/${userId}`)
		}
	}
	return(
		<ContentBlock>
			<DataTable
				isInsideContentBlock
				columns={cols}
				data={data.users || []}
				withColFilter
				label={t('closing_section.sub_sections.user')}
				onRowClick={gotoUser}
			/>
		</ContentBlock>
	)
}

export default withRouter(Users)
